import React, { useEffect, useState } from "react";
import Header from "../components/Admin/header/Header";
import Sidebar from "../components/Admin/Sidebar/Sidebar";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  RadioGroup,
  Radio,
  Grid2,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import { Close } from "@mui/icons-material";
const roomChargeHeadLabel = [
  {
    id: 1,
    label: "Bed Category",
    value: "bedCategory",
  },
  {
    id: 2,
    label: "Day",
    value: "day",
  },

  {
    id: 6,
    label: "",
    value: "",
    align: "right",
  },
];
const amountPercentHeadLabel = [
  {
    id: 1,
    label: "Category",
    value: "category",
  },
  {
    id: 2,
    label: "Difference rate",
    value: "differenceRate",
  },
  {
    id: 3,
    label: "Finale Rate",
    value: "finalrate",
  },

  {
    id: 6,
    label: "",
    value: "",
    align: "right",
  },
];
const associativeItemHeadLabel = [
  {
    id: 1,
    label: "Name ",
    value: "name",
  },
  {
    id: 2,
    label: "Quantity",
    value: "quantity",
  },
  {
    id: 3,
    label: "Value",
    value: "value",
  },
  {
    id: 4,
    label: "Type",
    value: "type",
  },

  {
    id: 6,
    label: "",
    value: "",
    align: "right",
  },
];
const applicableTaxesHeadLabel = [
  {
    id: 1,
    label: "Tax ",
    value: "tax",
  },
  {
    id: 2,
    label: "Dependent Tax",
    value: "dependenttax",
  },
  {
    id: 3,
    label: "Start Date",
    value: "startDate",
  },
  {
    id: 4,
    label: "End Date",
    value: "endDate",
  },
  {
    id: 4,
    label: "Status",
    value: "status",
  },

  {
    id: 6,
    label: "",
    value: "",
    align: "right",
  },
];

export default function MasterPackageEdit() {
  const [roomChargesList, setRoomChargesList] = useState([]);
  const [amountPercentList, setAmountPercentList] = useState([]);
  const [associativeItemList, setAssociativeItemList] = useState([]);
  const [applicableTaxesList, setApplicableTaxesList] = useState([]);

  const handleAddTableRow = (currentElement, currentState, newRowData) => {
    currentState([
      ...currentElement,
      { ...newRowData, id: currentElement?.length + 1 },
    ]);
  };

  // Remove medicine
  const handleRemoveTableRow = (id, currentElement, currentState) => {
    currentState(currentElement?.filter((medicine) => medicine?.id !== id));
  };
  return (
    <Container maxWidth={false} disableGutters>
      <Header />
      <Box sx={{ display: "flex" }}>
        <Box>
          <Sidebar />
        </Box>

        <Box
          component="form"
          sx={{ width: "100%", pr: "90px", py: "20px" }}
          // onSubmit={handleSubmit}
        >
          {/* enter item details */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: "20px",
            }}
          >
            <Typography sx={{ color: "rgba(93, 106, 130, 1)", fontSize: 20 }}>
              Edit Package Details
            </Typography>
            <IconButton>
              <CloseIcon />
            </IconButton>
          </Box>
          {/* first box */}
          <Box
            sx={{
              backgroundColor: "rgba(240, 247, 252, 1)",
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
            }}
          >
            <Typography sx={{ mb: "20px", color: "rgba(93, 106, 130, 1)" }}>
              Rates
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  options={[]}
                  getOptionLabel={(option) => option?.countryName || ""}
                  renderInput={(params) => (
                    <TextField {...params} label="Code" name="code" fullWidth />
                  )}
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  options={[]}
                  getOptionLabel={(option) => option?.countryName || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Item Barcode"
                      name="itemBarcode"
                      fullWidth
                    />
                  )}
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  options={[]}
                  getOptionLabel={(option) => option?.countryName || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Item Name"
                      name="itemName"
                      fullWidth
                    />
                  )}
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  options={[]}
                  getOptionLabel={(option) => option?.countryName || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Quantity"
                      name="quantity"
                      fullWidth
                    />
                  )}
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              border: `1px solid #CCD4DA`,
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
              fontSize: "14px",
              color: "#5D6A82",
            }}
          >
            <Typography sx={{ color: "inherit", fontSize: "14px" }}>
              Room Charges
            </Typography>
            <Box sx={{ p: "10px" }}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue={"bedCategoryWisedays"}
                defaultChecked={"bedCategoryWisedays"}
              >
                <FormControlLabel
                  value="bedCategoryWisedays"
                  control={<Radio />}
                  label="Bed Category Wise Days"
                />
                <FormControlLabel
                  value="bedCategoryWiseMaximumDaysLimit"
                  control={<Radio />}
                  label="Bed Category Wise Maximum Days Limit"
                />
              </RadioGroup>
            </Box>

            {/* Table */}

            <TableContainer
              sx={{ border: "1px solid #CCD4DA", borderRadius: "12px" }}
            >
              <Table
                aria-label="inhouse medicines table"
                sx={{ minWidth: 800 }}
              >
                <TableHead
                  sx={{
                    bgcolor: "#EAEAEA",
                  }}
                >
                  <TableRow>
                    {roomChargeHeadLabel?.map((option) => (
                      <TableCell
                        key={option?.id}
                        sx={{
                          textAlign: option?.align || "left",
                          color: "#5D6A82",
                        }}
                      >
                        {option?.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {roomChargesList?.map((row) => (
                    <TableRow key={row?.id}>
                      {roomChargeHeadLabel?.map((column, index) =>
                        index === roomChargeHeadLabel?.length - 1 ? (
                          <TableCell
                            key={column?.id}
                            sx={{
                              textAlign: "right",
                              color: "#5D6A82",
                            }}
                          >
                            <Close
                              sx={{
                                cursor: "pointer",
                                fontSize: "18px",
                              }}
                              onClick={() =>
                                handleRemoveTableRow(
                                  row?.id,
                                  roomChargesList,
                                  setRoomChargesList
                                )
                              }
                            />
                          </TableCell>
                        ) : (
                          <TableCell key={column?.id} sx={{ color: "#5D6A82" }}>
                            {row[column?.value]}
                          </TableCell>
                        )
                      )}
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell
                      // colSpan={12}
                      sx={{ color: "#92A6CC", cursor: "pointer" }}
                      onClick={() =>
                        handleAddTableRow(
                          roomChargesList,
                          setRoomChargesList,
                          {}
                        )
                      }
                    >
                      + Add item
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box
            sx={{
              border: `1px solid #CCD4DA`,
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
              fontSize: "14px",
              color: "#5D6A82",
            }}
          >
            <Typography sx={{ color: "inherit", fontSize: "14px", pb: "10px" }}>
              Room Charges
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Normal Rate (Rs)"
                  required
                  name="normalRate"
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Claim Rate (Rs)"
                  required
                  name="claimRate"
                  fullWidth
                  sx={{ bgcolor: "white" }}
                />
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              border: `1px solid #CCD4DA`,
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
              fontSize: "14px",
              color: "#5D6A82",
            }}
          >
            <Typography sx={{ color: "inherit", fontSize: "14px", pb: "10px" }}>
              Amount Percent Applied on the normal rate based on bed category
            </Typography>

            {/* Table */}

            <TableContainer
              sx={{ border: "1px solid #CCD4DA", borderRadius: "12px" }}
            >
              <Table
                aria-label="inhouse medicines table"
                sx={{ minWidth: 800 }}
              >
                <TableHead
                  sx={{
                    bgcolor: "#EAEAEA",
                  }}
                >
                  <TableRow>
                    {amountPercentHeadLabel?.map((option) => (
                      <TableCell
                        key={option?.id}
                        sx={{
                          textAlign: option?.align || "left",
                          color: "#5D6A82",
                        }}
                      >
                        {option?.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {amountPercentList?.map((row) => (
                    <TableRow key={row?.id}>
                      {amountPercentHeadLabel?.map((column, index) =>
                        index === amountPercentHeadLabel?.length - 1 ? (
                          <TableCell
                            key={column?.id}
                            sx={{
                              textAlign: "right",
                              color: "#5D6A82",
                            }}
                          >
                            <Close
                              sx={{
                                cursor: "pointer",
                                fontSize: "18px",
                              }}
                              onClick={() =>
                                handleRemoveTableRow(
                                  row?.id,
                                  amountPercentList,
                                  setAmountPercentList
                                )
                              }
                            />
                          </TableCell>
                        ) : (
                          <TableCell key={column?.id} sx={{ color: "#5D6A82" }}>
                            {row[column?.value]}
                          </TableCell>
                        )
                      )}
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell
                      // colSpan={12}
                      sx={{ color: "#92A6CC", cursor: "pointer" }}
                      onClick={() =>
                        handleAddTableRow(
                          amountPercentList,
                          setAmountPercentList,
                          {}
                        )
                      }
                    >
                      + Add item
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          <Box
            sx={{
              border: `1px solid #CCD4DA`,
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
              fontSize: "14px",
              color: "#5D6A82",
            }}
          >
            <Typography sx={{ color: "inherit", fontSize: "14px", pb: "10px" }}>
              Associative Item
            </Typography>

            {/* Table */}

            <TableContainer
              sx={{ border: "1px solid #CCD4DA", borderRadius: "12px" }}
            >
              <Table
                aria-label="inhouse medicines table"
                sx={{ minWidth: 800 }}
              >
                <TableHead
                  sx={{
                    bgcolor: "#EAEAEA",
                  }}
                >
                  <TableRow>
                    {associativeItemHeadLabel?.map((option) => (
                      <TableCell
                        key={option?.id}
                        sx={{
                          textAlign: option?.align || "left",
                          color: "#5D6A82",
                        }}
                      >
                        {option?.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {associativeItemList?.map((row) => (
                    <TableRow key={row?.id}>
                      {associativeItemHeadLabel?.map((column, index) =>
                        index === associativeItemHeadLabel?.length - 1 ? (
                          <TableCell
                            key={column?.id}
                            sx={{
                              textAlign: "right",
                              color: "#5D6A82",
                            }}
                          >
                            <Close
                              sx={{
                                cursor: "pointer",
                                fontSize: "18px",
                              }}
                              onClick={() =>
                                handleRemoveTableRow(
                                  row?.id,
                                  associativeItemList,
                                  setAssociativeItemList
                                )
                              }
                            />
                          </TableCell>
                        ) : (
                          <TableCell key={column?.id} sx={{ color: "#5D6A82" }}>
                            {row[column?.value]}
                          </TableCell>
                        )
                      )}
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell
                      // colSpan={12}
                      sx={{ color: "#92A6CC", cursor: "pointer" }}
                      onClick={() =>
                        handleAddTableRow(
                          associativeItemList,
                          setAssociativeItemList,
                          {}
                        )
                      }
                    >
                      + Add item
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box
            sx={{
              border: `1px solid #CCD4DA`,
              borderRadius: "12px",
              mb: "30px",
              p: "20px",
              fontSize: "14px",
              color: "#5D6A82",
            }}
          >
            <Typography sx={{ color: "inherit", fontSize: "14px" }}>
              Applicable Taxes
            </Typography>
            <Box sx={{ p: "10px" }}>
              <FormControlLabel
                control={<Checkbox name="applyTax" />}
                label="Apply Tax"
              />
            </Box>

            {/* Table */}

            <TableContainer
              sx={{ border: "1px solid #CCD4DA", borderRadius: "12px" }}
            >
              <Table
                aria-label="inhouse medicines table"
                sx={{ minWidth: 800 }}
              >
                <TableHead
                  sx={{
                    bgcolor: "#EAEAEA",
                  }}
                >
                  <TableRow>
                    {applicableTaxesHeadLabel?.map((option) => (
                      <TableCell
                        key={option?.id}
                        sx={{
                          textAlign: option?.align || "left",
                          color: "#5D6A82",
                        }}
                      >
                        {option?.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {applicableTaxesList?.map((row) => (
                    <TableRow key={row?.id}>
                      {applicableTaxesHeadLabel?.map((column, index) =>
                        index === applicableTaxesHeadLabel?.length - 1 ? (
                          <TableCell
                            key={column?.id}
                            sx={{
                              textAlign: "right",
                              color: "#5D6A82",
                            }}
                          >
                            <Close
                              sx={{
                                cursor: "pointer",
                                fontSize: "18px",
                              }}
                              onClick={() =>
                                handleRemoveTableRow(
                                  row?.id,
                                  applicableTaxesList,
                                  setApplicableTaxesList
                                )
                              }
                            />
                          </TableCell>
                        ) : (
                          <TableCell key={column?.id} sx={{ color: "#5D6A82" }}>
                            {row[column?.value]}
                          </TableCell>
                        )
                      )}
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell
                      // colSpan={12}
                      sx={{ color: "#92A6CC", cursor: "pointer" }}
                      onClick={() =>
                        handleAddTableRow(
                          applicableTaxesList,
                          setApplicableTaxesList,
                          {}
                        )
                      }
                    >
                      + Add item
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* save button */}
          <Box sx={{ display: "flex", justifyContent: "center", mt: "20px" }}>
            <Button
              variant="contained"
              type="submit"
              sx={{
                textTransform: "none",
                backgroundColor: "rgba(1, 121, 176, 1)",
                width: "150px",
              }}
              // disabled={isLoading}
            >
              Update
            </Button>
          </Box>
        </Box>
      </Box>
    </Container>
  );
}
